import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter, Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class SEp2 extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Special Episode 4: Hangul, the Korean Alphabet</h1>
                        <h5 className="korean-title">특별 에피소드 4: 한글</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

{/* INTRO */}
한글 (han gul) – the Korean alphabetical writing system  <br></br>
조선 (jo seon) — Joseon, a kingdom that ruled the Korean peninsula from 1392 to 1897  <br></br>
세종 (se jong) — the name of the king that created hangul (pictured below) <br></br>
<img className="epPic-m" src="https://i0.wp.com/londonkoreanlinks.net/wp-content/uploads/2016/08/Sejong.jpg"></img><br></br>
창제하다 (chang jae ha da) — to create <br></br>

 <br></br>
{/* hanja */}
한자 (han ja) — chinese characters that Koreans used to write Korean before hangul was invented (pictured below) <br></br>
<img className="epPic-m" src="https://mblogthumb-phinf.pstatic.net/MjAxODEyMjFfMjE4/MDAxNTQ1MzYzNzU4OTIw.eFjd7Fc0qWX-R1qeXJyX7__We-X2RqOk3K2MQVGlyg8g.PedmmYuieCqFGDpECcS-1i9lvVXHNNa2dNsBu1mCo4Yg.JPEG.suji5024/8급한자001.jpg?type=w800"></img><br></br>
쓰다 (sseu da) — to use <br></br>
중국 (joong gook) — China <br></br>
다르다 (da reu da) — to be different <br></br>
어렵다 (uh ryup da) — to be difficult <br></br>
백성 (baek sung) — people of a nation <br></br>
글 (geul) — writing <br></br>
읽다 (il da) — to read <br></br>

 <br></br>
{/* 훈민정음 */}
만들다 (man deul da) — to create <br></br>
훈민정음 (hoon min jung eum) — the book that recorded the Korean alphabet (hangul) and explained how to use it <br></br>
조선왕조실록 — the Veritable Records of the Joseon Dynasty <br></br>
가르치다 (ga reu chi da) — to teach <br></br>
바른 (bah reun) — correct <br></br>
소리 (so ri) — sound <br></br>

 <br></br>
{/* hall of worthies */}
한글날 (han gul nal) — Hangul Day (October 9th) <br></br>
쉽게 (ship gae) — easily <br></br>
집현전 (jip hyun jun) — Hall of Worthies <br></br>
반대하다 (ban dae ha da) — to oppose <br></br>

 <br></br>
{/* use */}
연산군 (yeon san goon) — the king that outlaws the use of hangul in 1504 <br></br>
독재자 (dok jae jah) — dictator <br></br>
소설 (so sul) — story <br></br>
시 (si) — poem <br></br>
초등학교 (cho deung hak gyo) — elementary school <br></br>
사용 (sah yong) — use <br></br>
줄어들다 (jul uh deul da) — to decrease <br></br>

<br></br>
The Korean alphabet Hangul (한글) is shown below: <br></br>
<img className="epPic" src="https://miro.medium.com/max/653/1*jNtRuyYqgdh4Ujb06DBKdA.png"></img><br></br>
Some possible combinations in Hangul:<br></br>
<img className="epPic" src="https://i.pinimg.com/originals/0a/6c/1c/0a6c1c5813515c2e729cd9d0a006fa8a.jpg"></img><br></br>
Learn more about hangul's origin <a target="_blank" href="https://www.youtube.com/watch?v=K53oCDZPPiw">here</a>!<br></br>
Learn how to read hangul with the comic <a target="_blank" href="https://9gag.com/gag/3968335">here</a>!<br></br>
Learn how to read hangul with the video <a target="_blank" href="https://www.youtube.com/watch?v=85qJXvyFrIc">here</a>  <br></br>

 <br></br>
{/* td */}
세종대왕 (se jong dae wang) — Great King Sejong <br></br>
스승의 날 (seu seung eh nal) — Teacher’s day <br></br>


                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <SEp2></SEp2>
        </div>
    );
}


  const Sepisode2 = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Sepisode2;